import { render, staticRenderFns } from "./approvalHistory.vue?vue&type=template&id=0a655dbf"
import script from "./approvalHistory.vue?vue&type=script&lang=js"
export * from "./approvalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports